import { render, staticRenderFns } from "./ComGraficaVentasClientes.vue?vue&type=template&id=100a8ade"
import script from "./ComGraficaVentasClientes.vue?vue&type=script&lang=js"
export * from "./ComGraficaVentasClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports